import { useState } from "react";

export default function AISearch({ penId: propPenId }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const fallbackPenId = user?.penId;
  const penId = propPenId || fallbackPenId || "general";

  const ask = async () => {
    if (!q.trim() || !penId) return;

    try {
      setIsLoading(true);
      setRes("");

      let profileContext = "";
      if (user?.onboardingComplete) {
        const testsSummary = user.tests
          ?.filter(t => t.subject && t.marks)
          ?.map(t => `${t.type === 'target' ? 'Target' : 'Past'} Test: ${t.subject} (${t.marks} on ${t.date})`)
          .join(", ") || "None";
        
        profileContext = `[Student Info Context -> Class: ${user.studentClass}, Board: ${user.board}, Loves: ${user.favouriteSubject}, Dislikes: ${user.dislikedSubject}. Tests: ${testsSummary}]\n\n`;
      }

      const r = await fetch("/api/ai/ask", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          penId,
          question: profileContext + q.trim(),
        }),
      });

      const t = await r.text();
      setRes(t);
    } catch (e) {
      setRes("Something went wrong while asking the AI. Please try again.");
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      ask();
    }
  };

  return (
    <div className="w-full space-y-3 text-slate-100">
      <div className="flex items-center gap-2 text-xs text-slate-400">
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-slate-900 border border-slate-700 text-[10px]">
          AI
        </span>
        <p>
          Ask follow-up questions about your subjects, concepts, or practice
          problems.
        </p>
      </div>

      <div className="relative rounded-xl border border-slate-800 bg-slate-950/70 px-3 py-2 shadow-inner shadow-black/40">
        <div className="flex items-center gap-2">
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Ask anything about what you're studying..."
            className="flex-1 bg-transparent border-none outline-none text-sm text-slate-100 placeholder:text-slate-500"
          />
          <button
            onClick={ask}
            disabled={!q.trim() || isLoading || !penId}
            className="inline-flex items-center gap-1 rounded-lg bg-indigo-500 px-3 py-1.5 text-xs font-medium text-slate-50 hover:bg-indigo-400 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          >
            {isLoading ? (
              <span className="h-3 w-3 rounded-full border border-slate-900 border-t-transparent animate-spin" />
            ) : (
              <span>Ask</span>
            )}
          </button>
        </div>
      </div>

      {res && (
        <div className="max-h-56 overflow-y-auto rounded-xl border border-slate-800 bg-slate-950/80 p-3 text-xs leading-relaxed text-slate-200">
          {res}
        </div>
      )}
    </div>
  );
}
